export const LEAD_GENERATION_VERTICALS = {
  OZEMPIC: "ozempic",
  TALCUM: "talcum powder",
  DUPIXENT: "dupixent",
  DEPO_PROVERA: "depoprovera",
  HERNIA_MESH: "hernia-mesh",
  SSDI: "SSDI",
  ROBLOX: "roblox-addiction",
  RIDESHARE: "rideshare",
  HAIR_RELAXER: "hair-relaxer",
  ROUNDUP: "roundup",
  SOCIAL_MEDIA_ADDICTION: "social-media-addiction",
  
};
 